<app-loading *ngIf="contentReady"></app-loading>

<section
  class="login-page"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="atw-container login-container">
    <div class="login-shell">

      <div class="login-shell-header">
        <div class="login-title">
          <span class="login-section-badge">
            <b>{{ 'auth.login.badgeNumber' | transloco }}</b>
            {{ 'auth.login.badgeTitle' | transloco }}
          </span>

          <h1>
            {{ 'auth.login.heroTitleLine1' | transloco }}
            <strong>{{ 'auth.login.heroTitleStrong' | transloco }}</strong>
          </h1>

          <p>
            {{ 'auth.login.heroText' | transloco }}
          </p>
        </div>

        <div class="login-live-label">
          <span>✓</span>
          {{ 'auth.login.secureLabel' | transloco }}
        </div>
      </div>

      <div class="login-grid">

        <!-- Brand Side -->
        <div class="login-brand-card">
          <div class="brand-mark">
             <strong>IN</strong>
          </div>

          <span class="brand-tag">
            {{ 'auth.login.brandTag' | transloco }}
          </span>

          <h2>
            {{ 'auth.login.brandTitle' | transloco }}
          </h2>

          <p>
            {{ 'auth.login.brandText' | transloco }}
          </p>

          <div class="login-features">
            <div>
              <i>✓</i>
              <span>{{ 'auth.login.feature1' | transloco }}</span>
            </div>

            <div>
              <i>✓</i>
              <span>{{ 'auth.login.feature2' | transloco }}</span>
            </div>

            <div>
              <i>✓</i>
              <span>{{ 'auth.login.feature3' | transloco }}</span>
            </div>
          </div>

          <div class="brand-bottom-line">
            <span></span>
          </div>
        </div>

        <!-- Form Side -->
        <div class="login-form-card">
          <div class="login-card-head">
            <span class="login-badge">
              {{ 'auth.login.cardBadge' | transloco }}
            </span>

            <h2 *ngIf="!loggedIn">
              {{ 'auth.login.title' | transloco }}
            </h2>

            <h2 *ngIf="loggedIn">
              {{ 'auth.login.loggedInTitle' | transloco }}
            </h2>

            <p>
              {{
                loggedIn
                  ? ('auth.login.loggedInText' | transloco)
                  : ('auth.login.subtitle' | transloco)
              }}
            </p>
          </div>

          <div class="logged-card" *ngIf="loggedIn">
            <i>✓</i>
            <strong>{{ 'auth.login.alreadyLoggedIn' | transloco }}</strong>
          </div>

          <form
            class="login-form"
            [formGroup]="person"
            (ngSubmit)="onSubmit()"
            *ngIf="!loggedIn"
          >
            <div class="login-field">
              <label>{{ 'auth.login.phoneLabel' | transloco }}</label>

              <input
                type="text"
                formControlName="username"
                [placeholder]="'auth.login.phonePlaceholder' | transloco"
                autocomplete="username"
                [class.invalid]="isInvalid('username')"
              />

              <small *ngIf="isInvalid('username')">
                {{ 'auth.login.phoneRequired' | transloco }}
              </small>
            </div>

            <div class="login-field">
              <label>{{ 'auth.login.passwordLabel' | transloco }}</label>

              <div class="password-field">
                <input
                  [type]="isPasswordVisible ? 'text' : 'password'"
                  formControlName="password"
                  [placeholder]="'auth.login.passwordPlaceholder' | transloco"
                  autocomplete="current-password"
                  [class.invalid]="isInvalid('password')"
                />

                <button
                  type="button"
                  class="toggle-password"
                  (click)="togglePasswordVisibility()"
                >
                  {{
                    isPasswordVisible
                      ? ('auth.login.hidePassword' | transloco)
                      : ('auth.login.showPassword' | transloco)
                  }}
                </button>
              </div>

              <small *ngIf="isInvalid('password')">
                {{ 'auth.login.passwordRequired' | transloco }}
              </small>
            </div>

            <div class="login-note">
              <i>i</i>
              <span>{{ 'auth.login.welcomeText' | transloco }}</span>
            </div>

            <button
              type="submit"
              class="login-submit"
              [disabled]="contentReady || person.invalid"
            >

              {{
                contentReady
                  ? ('auth.login.loading' | transloco)
                  : ('auth.login.submit' | transloco)
              }}
            </button>

            <div class="register-link-container">
              <span>{{ 'auth.login.askForAccount' | transloco }}</span>

              <a routerLink="/create-user">
                {{ 'auth.login.createAccount' | transloco }}
              </a>
            </div>
          </form>
        </div>

      </div>

    </div>
  </div>
</section>